import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Header } from '@widgets/header';

/**
 * Student Section Layout
 *
 * Route: /:locale/student/*
 * Wraps all student pages with portal layout
 *
 * This file is automatically code-split by TanStack Router.
 */
export const Route = createFileRoute('/$locale/_authenticated/student')({
  component: StudentLayout,
});

function StudentLayout() {
  const { locale } = Route.useParams();

  return (
    <div className="flex min-h-full flex-col pt-16 min-[992px]:pt-0">
      <Header locale={locale} className="min-[992px]:hidden" />

      <main className="min-w-0 p-6">
        <Outlet />
      </main>
    </div>
  );
}
